import React from 'react';
import type { FC } from 'react';
import { match } from 'variant';
import { useAsync, Spinner, Text } from '@wix/cli-ui-kit';
import { useProjectModel } from '../../model.js';
import { assertBuildOutputExists } from '../../files/assert-build-output-exists.js';
import { ReleaseSite } from './ReleaseSite.js';
import { ReleaseApp } from './app-flow/ReleaseApp.js';
import { ReleaseVersionType } from './app-flow/types.js';

interface ReleaseCommandProps {
  baseUrl?: string;
  label?: string;
  comment?: string;
  versionType?: ReleaseVersionType;
}

export const ReleaseCommand: FC<ReleaseCommandProps> = (props) => {
  const {
    model: { projectFolder, config },
  } = useProjectModel();

  const { status } = useAsync(async () => {
    await assertBuildOutputExists(projectFolder);
  }, []);

  return match(status, {
    Error: () => null,
    Loading: () => (
      <Spinner text={<Text>Loading application details...</Text>} />
    ),
    Success: () => {
      return config.projectType === 'Site' ? (
        <ReleaseSite
          {...props}
          createMinorVersion={props.versionType === ReleaseVersionType.MINOR}
        />
      ) : (
        <ReleaseApp
          baseUrl={props.baseUrl}
          label={props.label}
          preEnteredComment={props.comment}
          preSelectedVersionType={props.versionType}
        />
      );
    },
  });
};
